import { updates, features, appEntry, topics, aboutData } from '@/mocks/niuniuData';

export function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1100px] mx-auto px-4 md:px-6 w-full">
        <div className="text-center mb-10">
          <span className="inline-block text-xs font-medium text-primary-500 bg-primary-50 px-3 py-1 rounded-full mb-3">实时追踪</span>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">最新快讯</h2>
          <p className="text-sm text-foreground-600 mt-2">紧跟影视圈动态，不错过每一次更新</p>
        </div>
        <div className="relative">
          <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-0.5 bg-background-200 -translate-x-1/2 hidden md:block"></div>
          <div className="space-y-6">
            {updates.map((item, idx) => (
              <div key={item.id} className={`flex flex-col md:flex-row gap-4 md:gap-8 items-start ${idx % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'}`}>
                <div className={`flex-1 ${idx % 2 === 0 ? 'md:text-right' : 'md:text-left'} hidden md:block`}>
                  {idx % 2 === 0 && (
                    <div className="bg-background-50 border border-background-200 rounded-xl p-4">
                      <div className="flex items-center justify-end gap-2 mb-1">
                        <span className="text-xs text-foreground-500">{item.time}</span>
                        <span className="text-xs bg-primary-100 text-primary-700 px-2 py-0.5 rounded-full font-medium">{item.tag}</span>
                      </div>
                      <h3 className="text-sm font-medium text-foreground-800">{item.title}</h3>
                    </div>
                  )}
                </div>
                <div className="flex-shrink-0 w-8 h-8 rounded-full bg-primary-500 flex items-center justify-center z-10 mx-auto md:mx-0">
                  <span className="text-xs text-white font-bold">{item.id}</span>
                </div>
                <div className={`flex-1 ${idx % 2 === 0 ? 'md:text-left' : 'md:text-right'}`}>
                  <div className="bg-background-50 border border-background-200 rounded-xl p-4">
                    <div className={`flex items-center gap-2 mb-1 ${idx % 2 !== 0 ? 'md:justify-end' : ''}`}>
                      <span className="text-xs bg-primary-100 text-primary-700 px-2 py-0.5 rounded-full font-medium">{item.tag}</span>
                      <span className="text-xs text-foreground-500">{item.time}</span>
                    </div>
                    <h3 className="text-sm font-medium text-foreground-800">{item.title}</h3>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1100px] mx-auto px-4 md:px-6 w-full">
        <div className="text-center mb-10">
          <span className="inline-block text-xs font-medium text-accent-500 bg-accent-50 px-3 py-1 rounded-full mb-3">为什么选择我们</span>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">平台优势</h2>
          <p className="text-sm text-foreground-600 mt-2">三大核心优势，打造极致观影体验</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {features.map((f) => (
            <div key={f.id} className="bg-background-50 border border-background-200 rounded-xl p-6 text-center group hover:border-primary-300 transition-colors">
              <div className="w-14 h-14 mx-auto mb-4 rounded-xl bg-primary-100 flex items-center justify-center">
                <i className={`${f.icon} text-2xl text-primary-500`}></i>
              </div>
              <h3 className="font-heading text-lg text-foreground-900 mb-2">{f.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1100px] mx-auto px-4 md:px-6 w-full">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12 bg-background-50 border border-background-200 rounded-2xl p-8 md:p-12">
          <div className="flex-shrink-0">
            <div className="w-40 h-40 md:w-48 md:h-48 rounded-3xl bg-gradient-to-br from-primary-400 to-accent-500 flex items-center justify-center shadow-lg">
              <i className="ri-smartphone-line text-6xl text-white"></i>
            </div>
          </div>
          <div className="flex-1 text-center lg:text-left">
            <div className="inline-flex items-center gap-2 bg-accent-100 text-accent-700 text-xs font-medium px-3 py-1 rounded-full mb-3">
              <i className="ri-sparkling-line"></i>
              {appEntry.badge}
            </div>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-1">{appEntry.title}</h2>
            <p className="text-lg text-primary-500 font-medium mb-3">{appEntry.subtitle}</p>
            <p className="text-sm text-foreground-600 leading-relaxed max-w-lg mx-auto lg:mx-0 mb-5">{appEntry.desc}</p>
            <div className="flex flex-col sm:flex-row justify-center lg:justify-start gap-3">
              <a href="#" className="inline-flex items-center justify-center gap-2 bg-foreground-900 hover:bg-foreground-800 text-white font-medium px-5 py-2.5 rounded-lg transition-colors whitespace-nowrap cursor-pointer text-sm">
                <i className="ri-apple-fill text-lg"></i>
                App Store 下载
              </a>
              <a href="#" className="inline-flex items-center justify-center gap-2 bg-primary-500 hover:bg-primary-600 text-white font-medium px-5 py-2.5 rounded-lg transition-colors whitespace-nowrap cursor-pointer text-sm">
                <i className="ri-android-fill text-lg"></i>
                Android 下载
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1100px] mx-auto px-4 md:px-6 w-full">
        <div className="text-center mb-10">
          <span className="inline-block text-xs font-medium text-accent-500 bg-accent-50 px-3 py-1 rounded-full mb-3">大家都在聊</span>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">热门话题</h2>
          <p className="text-sm text-foreground-600 mt-2">实时热议影视话题，加入讨论</p>
        </div>
        <div className="flex flex-wrap justify-center gap-3">
          {topics.map((t) => (
            <a
              key={t.id}
              href="#"
              className="group flex items-center gap-2 bg-background-50 border border-background-200 hover:border-primary-300 rounded-full px-4 py-2 transition-colors cursor-pointer"
            >
              <span className={`w-2 h-2 rounded-full ${t.color} flex-shrink-0`}></span>
              <span className="text-sm font-medium text-foreground-800 whitespace-nowrap">{t.name}</span>
              <span className="text-xs text-foreground-500 whitespace-nowrap">{t.heat}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}

export function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1100px] mx-auto px-4 md:px-6 w-full">
        <div className="text-center mb-10">
          <span className="inline-block text-xs font-medium text-primary-500 bg-primary-50 px-3 py-1 rounded-full mb-3">独家内容</span>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">精彩视频</h2>
          <p className="text-sm text-foreground-600 mt-2">幕后花絮、明星访谈、观影指南一站看</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="bg-background-50 border border-background-200 rounded-xl overflow-hidden group cursor-pointer hover:border-primary-300 transition-colors">
            <div className="relative aspect-video bg-background-200 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=cinematic%20film%20behind%20the%20scenes%20photography%20with%20warm%20lighting%20and%20movie%20set%20atmosphere%2C%20professional%20video%20production%20scene%2C%20film%20camera%20equipment%2C%20soft%20golden%20tones%2C%20elegant%20composition&width=800&height=450&seq=media-card-01&orientation=landscape"
                alt="流浪地球3 幕后特辑"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-black/20 flex items-center justify-center">
                <div className="w-12 h-12 rounded-full bg-white/90 flex items-center justify-center">
                  <i className="ri-play-fill text-xl text-primary-500 ml-0.5"></i>
                </div>
              </div>
              <div className="absolute bottom-2 right-2 bg-black/70 text-white text-xs px-2 py-1 rounded">48:32</div>
            </div>
            <div className="p-4">
              <span className="text-xs text-primary-500 font-medium">独家幕后</span>
              <h3 className="font-heading text-base text-foreground-900 mt-1 mb-2 line-clamp-2">流浪地球3 幕后特辑</h3>
              <p className="text-xs text-foreground-600 line-clamp-2 mb-2">郭帆导演亲自解读太阳氦闪危机设定，揭秘数字生命计划背后的科学逻辑与视觉特效制作幕后故事。</p>
              <div className="flex items-center gap-1 text-xs text-foreground-500">
                <i className="ri-eye-line"></i>
                <span>256万 次观看</span>
              </div>
            </div>
          </div>
          <div className="bg-background-50 border border-background-200 rounded-xl overflow-hidden group cursor-pointer hover:border-primary-300 transition-colors">
            <div className="relative aspect-video bg-background-200 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=film%20director%20interview%20scene%20with%20cast%20members%20on%20sofa%2C%20warm%20studio%20lighting%2C%20movie%20posters%20in%20background%2C%20professional%20interview%20setup%2C%20golden%20and%20red%20cinematic%20tones&width=800&height=450&seq=media-card-02&orientation=landscape"
                alt="封神第二部 主创访谈"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-black/20 flex items-center justify-center">
                <div className="w-12 h-12 rounded-full bg-white/90 flex items-center justify-center">
                  <i className="ri-play-fill text-xl text-primary-500 ml-0.5"></i>
                </div>
              </div>
              <div className="absolute bottom-2 right-2 bg-black/70 text-white text-xs px-2 py-1 rounded">32:15</div>
            </div>
            <div className="p-4">
              <span className="text-xs text-primary-500 font-medium">明星专访</span>
              <h3 className="font-heading text-base text-foreground-900 mt-1 mb-2 line-clamp-2">封神第二部 主创访谈</h3>
              <p className="text-xs text-foreground-600 line-clamp-2 mb-2">乌尔善导演携费翔、黄渤、于适等主创畅谈封神宇宙构建，分享殷郊复活与闻仲大军的拍摄趣事。</p>
              <div className="flex items-center gap-1 text-xs text-foreground-500">
                <i className="ri-eye-line"></i>
                <span>189万 次观看</span>
              </div>
            </div>
          </div>
          <div className="bg-background-50 border border-background-200 rounded-xl overflow-hidden group cursor-pointer hover:border-primary-300 transition-colors">
            <div className="relative aspect-video bg-background-200 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=colorful%20summer%20movie%20posters%20collage%20on%20a%20desk%20with%20notebook%20and%20pen%2C%20warm%20natural%20light%20from%20window%2C%20film%20planning%20and%20recommendation%20aesthetic%2C%20golden%20hour%20tones%2C%20cozy%20atmosphere&width=800&height=450&seq=media-card-03&orientation=landscape"
                alt="2026暑期档观影指南"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-black/20 flex items-center justify-center">
                <div className="w-12 h-12 rounded-full bg-white/90 flex items-center justify-center">
                  <i className="ri-play-fill text-xl text-primary-500 ml-0.5"></i>
                </div>
              </div>
              <div className="absolute bottom-2 right-2 bg-black/70 text-white text-xs px-2 py-1 rounded">15:40</div>
            </div>
            <div className="p-4">
              <span className="text-xs text-primary-500 font-medium">观影指南</span>
              <h3 className="font-heading text-base text-foreground-900 mt-1 mb-2 line-clamp-2">2026暑期档观影指南</h3>
              <p className="text-xs text-foreground-600 line-clamp-2 mb-2">盘点暑期档最值得期待的15部大片，从科幻巨制到温情喜剧，一份清单帮你规划整个夏天的观影安排。</p>
              <div className="flex items-center gap-1 text-xs text-foreground-500">
                <i className="ri-eye-line"></i>
                <span>432万 次观看</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1100px] mx-auto px-4 md:px-6 w-full">
        <div className="text-center mb-10">
          <span className="inline-block text-xs font-medium text-accent-500 bg-accent-50 px-3 py-1 rounded-full mb-3">品牌故事</span>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">{aboutData.title}</h2>
        </div>
        <div className="max-w-3xl mx-auto">
          <div className="space-y-4 mb-10">
            {aboutData.paragraphs.map((p, i) => (
              <p key={i} className="text-sm md:text-base text-foreground-700 leading-relaxed">{p}</p>
            ))}
          </div>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {aboutData.stats.map((s) => (
              <div key={s.label} className="text-center p-4 bg-background-100 rounded-xl">
                <div className="text-2xl md:text-3xl font-bold text-primary-500 font-heading">{s.value}</div>
                <div className="text-xs text-foreground-600 mt-1">{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}